import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../../../shared/api/axios-instance';
import { CategoryDto } from '../../../../shared/dtos/category.dto';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';

export const getCategories = <TReturnType>(
  mapper: (dto: CategoryDto) => TReturnType
) =>
  createAsyncThunk<TReturnType[], void, Record<string, unknown>>(
    'get-categories',
    async (): Promise<TReturnType[]> => {
      const { data }: AxiosResponse<CategoryDto[]> = await axiosInstance.get(
        Endpoints.GET_CATEGORIES
      );

      return data.map(mapper);
    }
  );
